import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import axios from "axios";
import {header} from "../../../../../../../../components/api/Header";
import {addFunc, bolFunc, foiz} from "../../../../../../../../components/functions/Mathematik";
import {CalcMaydon, CalcMaydonByTartib} from "../../../../../../../../components/sfr/maydon";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot2(props) {
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const [types, setTypes] = useState([])
    const season = localStorage.getItem('sfr-hm-season')
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    const cropids = crops1?JSON.parse(crops1):{}
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const [tartibi, setTartibi] = useState({})
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/ekintypes?crops="+cropids,header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setTypes(res.data)
            }
        }
        const fetchTartib = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/sugorish_tartibi?crops="+cropids+"&season=noveg",header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setTartibi(res.data)
            }
        }
        if(cropids){
            fetchData()
            fetchTartib()
        }
    },[])
    const xisobot = () => {
        const maydonsum = CalcMaydon(maydon,cropids)
        const maydonsummultiplebytartib = CalcMaydonByTartib(maydon,cropids,tartibi)
        if(manbalar.length){
            let obj = [];
            let tr = 1;
            let jamikanallarboyicha = [];
            manbalar.map((manba,i)=>{
                let jami_manba = [];
                let istemolchi = istemolchilar.filter(istemolchi=>istemolchi.mid == manba.id)
                if(istemolchi.length){
                    istemolchi.map(ist => {
                        let maydonlar = [0];
                        let keltirilgan_maydon = 0
                        types.map(t=>{
                            if(t.grouped){
                                let gjami = [];
                                t.ekin.map(tch=>{
                                    gjami.push(maydonsum['i'+ist.id]?maydonsum['i'+ist.id]['e'+tch.id]:0)
                                })
                                maydonlar.push(gjami.reduce((a, b) => a + b, 0))
                            }
                            t.ekin.map(tch=>{
                                maydonlar[0] = addFunc(maydonlar[0],maydonsum['i'+ist.id]?maydonsum['i'+ist.id]['e'+tch.id]:0)
                                maydonlar.push(maydonsum['i'+ist.id]?maydonsum['i'+ist.id]['e'+tch.id]:0)
                            })


                            if(t.grouped) {
                                t.ekin.map(tch => {
                                    keltirilgan_maydon = addFunc(keltirilgan_maydon,maydonsummultiplebytartib['i' + ist.id] ? maydonsummultiplebytartib['i' + ist.id]['e' + tch.id]:0)
                                })
                                maydonlar.push(keltirilgan_maydon)
                            }
                        })
                        for(var jm = 0; jm < maydonlar.length; jm++){
                            jami_manba[jm] = addFunc(jami_manba[jm],maydonlar[jm])
                        }
                    })
                }

                obj.push(
                    <tr key={i+"b"}>
                        <th>{i+1}</th>
                        <th>Jami {manba.name} bo'yicha</th>
                        {
                            jami_manba.map((m,i)=>{
                                return <td key={i}>{m?m:''}</td>
                            })
                        }
                    </tr>
                )
                for(var jm = 0; jm < jami_manba.length; jm++){
                    jamikanallarboyicha[jm] = addFunc(jamikanallarboyicha[jm],jami_manba[jm])
                }

            })
            obj.push(
                <tr key="jami">
                    <th colSpan={2} >Jami {user.district} bo'yicha</th>
                    {
                        jamikanallarboyicha.map((m,i)=>{
                            return <th key={i} className="text-center">{m?m:''}</th>
                        })
                    }
                </tr>
            )
            return obj;
        }
    }
    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - № 1 a</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning manbalar bo'yicha {year} - {parseInt(year)+1} yilning kuzgi-qishki davrida sho'r yuviladigan, nam suv beriladigan va boshqa sug'orish ishlari amalga oshiriladigan yer maydonlari</h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-3">gektar</div>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered" >
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th className="text-center" rowSpan="3">№</th>
                                <th className="text-center" rowSpan="3">Manbalar nomi</th>
                                <th className="text-center" rowSpan="3">Fizik maydon, ga</th>
                                {
                                    types.length?
                                        types.map((t,i)=>{
                                            return <th
                                                className="text-center"
                                                rowSpan={t.grouped?1:3}
                                                key={i}
                                                colSpan={t.grouped?t.ekin.length+2:1}>{t.name}
                                            </th>
                                        })
                                        :null
                                }
                            </tr>
                            <tr>
                                {
                                    types.length?
                                        types.map((t,i)=>{
                                            if(t.grouped){
                                                if(t.name == 'Sho`r yuvish'){
                                                    return [0,1,2].map((p,k)=>{
                                                        if(p == 0) {
                                                            return <th className="text-center" rowSpan={2} key={k}>Jami, ga</th>
                                                        }else if(p==1){
                                                            return <th className="text-center" key={k} colSpan={t.ekin.length}>Shu jumladan</th>
                                                        }else{
                                                            return <th className="text-center" rowSpan={2} key={k}>Keltirilgan maydon (ga/sho'r yuvish)</th>
                                                        }
                                                    })
                                                }else{
                                                    return [0,1,2].map((p,k)=>{
                                                        if(p == 0) {
                                                            return <th className="text-center" rowSpan={2} key={k}>Jami sug'orish ishlari, ga</th>
                                                        }else if(p == 1){
                                                            return <th className="text-center" key={k} colSpan={t.ekin.length}>Shu jumladan</th>
                                                        }else{
                                                            return <th className="text-center" key={k} rowSpan={2}>Keltirilgan maydon (ga/sug'orish)</th>
                                                        }
                                                    })
                                                }
                                            }
                                        })
                                        :null
                                }
                            </tr>
                            <tr>
                                {
                                    types.length?
                                        types.map((t,i)=>{
                                            return t.grouped? t.ekin.map((e,i)=>{
                                                return <th className="text-center" width="100px" key={i}>{e.name}</th>
                                            }):null
                                        })
                                        :null
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot2;